import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import SiteFooter from './components/SiteFooter';
import SiteHeader from './components/SiteHeader';
import Episode from './pages/Episode';
import Episodes from './pages/Episodes';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import RogueliteVsRoguelike from './pages/RogueliteVsRoguelike';
import TierList from './pages/TierList';
import ScrollToTop from './components/ScrollToTop';

const App: React.FC = () => (
  <div className="flex min-h-screen flex-col bg-ink-900">
    <ScrollToTop />
    {/* Visually hidden until focused, so keyboard users can skip the nav. */}
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:bg-signal focus:px-5 focus:py-3 focus:font-display focus:text-sm focus:font-semibold focus:uppercase focus:tracking-[0.08em] focus:text-white"
    >
      Skip to content
    </a>
    <SiteHeader />
    <main id="main" className="flex-1">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/episodes" element={<Episodes />} />
        <Route path="/episodes/:slug" element={<Episode />} />
        <Route path="/tier-list" element={<TierList />} />
        <Route path="/roguelite-vs-roguelike" element={<RogueliteVsRoguelike />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
    <SiteFooter />
  </div>
);

export default App;
